const DEFAULT_EXTRA_FEATURE_DESCRIPTION = 'Cette fonctionnalité est disponible uniquement avec un abonnement Extra.'

export function useExtraFeature() {
  const userStore = useUserStore()
  const localePath = useLocalePath()
  const toast = useToast()

  const isExtraUser = computed(() => userStore.user?.extra == 1)

  function showExtraFeatureToast(description: string = DEFAULT_EXTRA_FEATURE_DESCRIPTION) {
    toast.add({
      title: 'Fonctionnalité Extra',
      description,
      color: 'warning',
      icon: 'i-mdi-star',
      actions: [
        {
          label: 'Découvrir l\'Extra',
          color: 'primary',
          variant: 'solid',
          to: localePath({ name: 'ExtraPage' }),
        },
      ],
    })
  }

  return {
    isExtraUser,
    showExtraFeatureToast,
  }
}
